import { BackendLogger } from './BackendLogger';

export class FetchResponseError extends Error {
    public readonly response: Response;
    public readonly responseBody: unknown;

    constructor(response: Response, responseBody: unknown) {
        super(`HTTP StatusCode: ${response.status}`);
        this.name = 'FetchResponseError';
        this.response = response;
        this.responseBody = responseBody;
    }
}

export async function createFetchResponseError(response: Response): Promise<FetchResponseError> {
    const responseText = await response.text();
    let responseBody: unknown = responseText;

    try {
        responseBody = responseText ? JSON.parse(responseText) : null;
    } catch {
        // Keep non-JSON error responses as text for backend logging.
    }

    return new FetchResponseError(response, responseBody);
}

function getResponseHeaders(response: Response): Record<string, string> {
    const headers: Record<string, string> = {};
    response.headers.forEach((value, key) => {
        headers[key] = value;
    });
    return headers;
}

export function handleFetchError(error: Error, postToBackendErrorLogger: boolean, apiUrl: string) {
    let errorString = '';

    if (error instanceof FetchResponseError) {
        errorString += `HTTP StatusCode: ${error.response.status}`;
        errorString += `, response object: ${JSON.stringify(error.responseBody)}`;
        errorString += `, headers: ${JSON.stringify(getResponseHeaders(error.response))}`;
    }

    if (error.name === 'AbortError') {
        errorString += `Request canceled${error.message}`;
    }

    errorString += `fetch() failed with "${error.name}: ${error.message}". Full error:\n${error.stack}`;
    if (postToBackendErrorLogger) {
        new BackendLogger(apiUrl).postError(errorString);
    } else {
        // eslint-disable-next-line
        console.warn(errorString);
    }
}
